import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

class InformationRequirementView extends PolylineEdge {
  getEndArrow() {
    const { model } = this.props;
    const { stroke } = model.getEdgeStyle();
    return h('path', {
      d: 'M 0 0 L -11 -5 L -11 5 Z',
      fill: stroke || '#1890ff',
      stroke: stroke || '#1890ff',
      transform: 'translate(1 0)',
    });
  }
}

class InformationRequirementModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);
    this.text = { ...this.text, value: '', editable: false };
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const t = getThemeStyle(this.graphModel, 'informationRequirement');
    style.stroke = t.stroke || '#1890ff';
    style.strokeWidth = t.strokeWidth || 1.5;
    return style;
  }
}

export const InformationRequirement = {
  type: 'dmn:InformationRequirement',
  view: InformationRequirementView,
  model: InformationRequirementModel,
};
